import React, { useState } from 'react'
import TopNavbar from '../components/topNavbar'
import * as Constants from '../src/constants'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import MainPage from '../pages/mainPage'
import PhotosPage from '../pages/photosPage'
import CameraPage from '../pages/cameraPage'
import { WebSocketProvider, useWebSocket } from '../src/contexts/WebSocketContext'
import useWakeLock from '../src/hooks/useWakeLock'

const App = () => {
  const [apikey, setApikey] = useState(localStorage.getItem('apikey'))

  const manualApikey = e => {
    e.preventDefault()

    let userKey = prompt('apikey', apikey ? apikey : '')

    if (userKey != null && userKey.length == 13) {
      localStorage.setItem('apikey', userKey)
      setApikey(userKey)
      // WebSocket will reconnect automatically via useEffect in WebSocketProvider
    }
  }

  return (
    <WebSocketProvider apikey={apikey}>
      <BrowserRouter>
        <AppContent apikey={apikey} manualApikey={manualApikey} />
      </BrowserRouter>
    </WebSocketProvider>
  )
}

const AppContent = ({ apikey, manualApikey }) => {
  const { config, connectionState, error } = useWebSocket()
  const sentinel = useWakeLock()

  // Derive oldData from connection state
  const oldData = connectionState !== 'connected'
  const machineName = config.name

  return (
    <>
      <TopNavbar
        oldData={oldData}
        apikey={apikey}
        manualApikey={manualApikey}
        machineName={machineName}
        sentinel={sentinel}
        connectionState={connectionState}
      />

      <Routes>
        <Route
          path='/'
          element={
            <MainPage
              apikey={apikey}
              error={error}
            />
          }
        />

        <Route path='/photos' element={<PhotosPage apikey={apikey} />} />
        <Route path='/camera' element={<CameraPage />} />
      </Routes>
    </>
  )
}

export default App
